export default class Graph {
    constructor(size) {
        this.size = size;
        this.adjMatrix = Array(size).fill(0).map(() => Array(size).fill(Infinity));
        this.vertexData = Array(size).fill('');
        this.accessibilityData = Array(size).fill(0).map(() => Array(size).fill(0));
    }
    addEdge(u, v, weight, oneWay) {
        if (0 <= u < this.size && 0 <= v < this.size) {
            this.adjMatrix[u][v] = weight;
            if (oneWay) return;
            
            this.adjMatrix[v][u] = weight;
        }
    }
    addVertexData(vertex, data) {
        if (0 <= vertex < this.size) {
            this.vertexData[vertex] = data;
        }
    }
    addAccessibility(u, v, accessibility) {
        if (0 <= u < this.size && 0 <= v < this.size) {
            this.accessibilityData[u][v] = accessibility;
            this.accessibilityData[v][u] = accessibility;
        }
    }
    dijkstra(start, accessibility) {
        const startVertex = this.vertexData.indexOf(start);
        const distances = Array(this.size).fill(Infinity);
        const predecessors = Array(this.size).fill(null);
        distances[startVertex] = 0;
        const visited = Array(this.size).fill(false);
        for (let _ = 0; _ < this.size; _++) {
            let minDistance = Infinity;
            let u = null;
            for (let i = 0; i < this.size; i++) {
                if (!visited[i] && distances[i] < minDistance) {
                    minDistance = distances[i];
                    u = i;
                }
            }
            if (u === null) {
                break;
            }
            visited[u] = true;
            for (let v = 0; v < this.size; v++) {
                if (accessibility && !this.accessibilityData[u][v]) {
                    continue;
                }
                if (this.adjMatrix[u][v] !== Infinity && !visited[v]) {
                    const alt = distances[u] + this.adjMatrix[u][v];
                    if (alt < distances[v]) {
                        distances[v] = alt;
                        predecessors[v] = u;
                    }
                }
            }
        }
        return [distances, predecessors];
    }
    getPath(predecessors, startVertex, endVertex) {
        const path = [];
        let current = this.vertexData.indexOf(endVertex);
        while (current !== null) {
            path.unshift(this.vertexData[current]);
            current = predecessors[current];
            if (current === this.vertexData.indexOf(startVertex)) {
                path.unshift(startVertex);
                break;
            }
        }
        
        return path;
    }
}